import { defineAsyncComponent } from 'vue'
import EoCustomIcon from './CustomIcon'

export default app => {
  app.component('EoTreeSelect', defineAsyncComponent(() => import('@ecoonline/vue-treeselect')))
  app.component('EoAdminPageHeader', defineAsyncComponent(() => import('./AdminPageHeader')))
  app.component('EoCard', defineAsyncComponent(() => import('./Card')))
  app.component('EoCollapsible', defineAsyncComponent(() => import('./Collapsible')))
  app.component('EoCustomIcon', EoCustomIcon)
  app.component('EoDetailWithPopup', defineAsyncComponent(() => import('./DetailWithPopup')))
  app.component('EcoForm', defineAsyncComponent(() => import('./EcoForm')))
  app.component('EoButton', defineAsyncComponent(() => import('./EoButton')))
  app.component('EoCheckbox', defineAsyncComponent(() => import('./EoCheckbox')))
  app.component('EoCheckboxGroup', defineAsyncComponent(() => import('./EoCheckboxGroup')))
  app.component('EoFormgroup', defineAsyncComponent(() => import('./EoFormgroup')))
  app.component('EoInput', defineAsyncComponent(() => import('./EoInput')))
  app.component('EoInputPassword', defineAsyncComponent(() => import('./EoInputPassword')))
  app.component('EoInputSensitive', defineAsyncComponent(() => import('./EoInputSensitive')))
  app.component('EoLabel', defineAsyncComponent(() => import('./EoLabel')))
  app.component('EoSelect', defineAsyncComponent(() => import('./EoSelect')))
  app.component('EoTextarea', defineAsyncComponent(() => import('./EoTextarea')))
  app.component('EoToggle', defineAsyncComponent(() => import('./EoToggle')))
  app.component('PlatformGlobalSystemNotifier', defineAsyncComponent(() => import('./GlobalSystemNotifier')))
  app.component('PlatformHeader', defineAsyncComponent(() => import('./Header')))
  app.component('EoIcon', defineAsyncComponent(() => import('./Icon')))
  app.component('EoLoadingSpinner', defineAsyncComponent(() => import('./LoadingSpinner')))
  app.component('EoLogInAsUserNotifier', defineAsyncComponent(() => import('./LogInAsUserNotifier')))
  app.component('EoPasswordProtectedField', defineAsyncComponent(() => import('./PasswordProtectedField')))
  app.component('EoProfileImage', defineAsyncComponent(() => import('./ProfileImage')))
  app.component('EoSystemNotifier', defineAsyncComponent(() => import('./SystemNotifier')))
  app.component('EoToggleBadge', defineAsyncComponent(() => import('./ToggleBadge')))
  app.component('PlatformWideCard', defineAsyncComponent(() => import('./WideCard')))
  app.component('AccessCheck', defineAsyncComponent(() => import('./AccessCheck')))
}
